(function () {
  function insertSubtitle() {
    var data = document.getElementById('kmf-subtitle-data');
    if (!data) return;
    var sub = (data.textContent || '').trim();
    if (!sub) return;
    var root = document.querySelector('.product-details');
    if (!root) return;
    if (root.querySelector('.kmf-product-subtitle')) return;
    var title = null;
    var heads = root.querySelectorAll('h1, h2, h3, h4');
    for (var i = 0; i < heads.length; i++) {
      if (!heads[i].closest('.view-product-title')) { title = heads[i]; break; }
    }
    if (!title) return;
    var p = document.createElement('p');
    p.className = 'kmf-product-subtitle';
    p.textContent = sub;
    p.setAttribute('style', 'margin:6px 0 0 0;font-size:0.9375rem;line-height:1.35;font-style:italic;opacity:0.72;');
    var wrap = title.closest('.text-block') || title.closest('.group-block') || title;
    (wrap.parentNode || title.parentNode).insertBefore(p, wrap.nextSibling);
  }
  function fixQualityRow() {
    var root = document.querySelector('.product-details');
    if (!root) return;
    var target = null;
    var els = root.querySelectorAll('em, span, p, div');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length === 0 && /COMFORT COLORS QUALITY/i.test(el.textContent)) { target = el; break; }
    }
    if (!target) return;
    if (target.getAttribute('data-kmf-badge') === '1') return;
    target.textContent = 'Genuine Comfort Colors® 1717 · premium garment-dyed cotton';
    target.setAttribute('data-kmf-badge', '1');
  }
  function addSpecStrip() {
    var root = document.querySelector('.product-details');
    if (!root) return;
    if (root.querySelector('.kmf-spec-strip')) return;
    var badge = root.querySelector('[data-kmf-badge="1"]');
    var anchor = badge ? (badge.closest('.text-block') || badge.closest('p') || badge) : null;
    if (!anchor || !anchor.parentNode) return;
    var strip = document.createElement('div');
    strip.className = 'kmf-spec-strip';
    strip.setAttribute('style', 'margin:5px 0 2px 0;font-size:0.8125rem;line-height:1.55;text-align:center;opacity:0.72;');
    strip.textContent = 'Ring-spun cotton · 6.1 oz garment-dyed · double-needle stitched · pre-shrunk, true to size · relaxed unisex fit';
    anchor.parentNode.insertBefore(strip, anchor.nextSibling);
  }
  function run() {
    try { insertSubtitle(); } catch (e) {}
    try { fixQualityRow(); } catch (e) {}
    try { addSpecStrip(); } catch (e) {}
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
